// extracted by mini-css-extract-plugin
module.exports = {"spinner-container":"m-ojoJnCmAAxEMxzDAwZ7","full-screen-h":"_2Gdbxt-EIQca5sT6iA2uXH"};